// extracted by mini-css-extract-plugin
export default {"output":"Output_output__cZRl4","outputTextarea":"Output_outputTextarea__W-9df","copyButton":"Output_copyButton__IHo0D"};